import React from 'react'

import Experiment from '@mc/experiments-react'
import { usePromotion } from '@mc/promo-utils'
import { usePromoGiftEnabled, GiftButton } from '@mc/promos'

import CTA from 'components/CTA'
import { trackPropsType } from 'components/CTA/events'
import { useTrackExperimentViewedFE } from 'libs/utils/usetrackExperimentViewedFe'

import { GLOBAL_CTAS_WHATS_IN_A_MEMBERSHIP_FLAG_NAME } from './constants'

interface WhatsInAMembershipExperimentProps {
  children: React.ReactNode
  location: string
  trackProps?: trackPropsType
}

export const WhatsInAMembershipExperiment = ({
  children,
  ...restProps
}: WhatsInAMembershipExperimentProps) => {
  const { giftEnabled } = usePromoGiftEnabled()
  const { isPromotionOn } = usePromotion()

  if (!giftEnabled || !isPromotionOn) return children

  return <Content {...restProps}>{children}</Content>
}

const Content = ({
  children,
  location,
  trackProps,
}: WhatsInAMembershipExperimentProps) => {
  useTrackExperimentViewedFE(GLOBAL_CTAS_WHATS_IN_A_MEMBERSHIP_FLAG_NAME)

  return (
    <Experiment
      name={GLOBAL_CTAS_WHATS_IN_A_MEMBERSHIP_FLAG_NAME}
      control={() => children}
      variant_1={() => (
        <>
          <div className='col-6 col-sm-4'>
            <GiftButton location={location} />
          </div>
          <div className='col-6 col-sm-4'>
            <CTA fullWidth trackProps={trackProps} />
          </div>
        </>
      )}
      track={true}
    />
  )
}
